import Main from './Main'
import Lista from './components/TiposPoliciaLista'
import Novo from './components/NovoTipoPolicia'

export default [
  {
    path: 'tipos-policia',
    name: 'config.tipos-policia',
    component: Main,
    redirect: { name: 'config.tipos-policia.list' },
    children: [
      {
        path: '/',
        name: 'config.tipos-policia.list',
        component: Lista
      },
      {
        path: 'registro',
        name: 'config.tipos-policia.novo',
        component: Novo
      },
      {
        path: ':id',
        name: 'config.tipos-policia.edit',
        component: Novo
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/policia-civil/policiais/tipos-policia/routes.js